import React, {useState} from "react";
import { ObjectSectionSelect, ObjectSubSectionSelect } from "../../../components/Select/domainSelects";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";
import { getAnObjectSections } from "../../../redux/actions/anObjectSectionActions";
import { getAnObjectSubSections } from "../../../redux/actions/anObjectSubSectionActions";

import { setValue } from "../../../functions/entityHelpers";

const filterFields = [
    {
        title: "Раздел",
        key: "sectionId",
        compareType: "equals",
        reducerKey: "anObjectSection",
        reducerArrayKey: "anObjectSections",
        reducerAction: getAnObjectSections,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
    {
        title: "Родительский подраздел",
        key: "parentId",
        compareType: "equals",
        reducerKey: "anObjectSubSection",
        reducerArrayKey: "anObjectSubSections",
        reducerAction: getAnObjectSubSections,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    }
]

const AnObjectSubSectionList = () => {
    const [entity, setEntity] = useState({});

    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="anObjectSubSection"
                hasCode={true}
                hasDescription={true}
                filterFields={filterFields}
                entity={entity}
                setEntity={setEntity}
                extraColumns={[
                    {title: "Раздел объекта", dataIndex: 'sectionId', key: 'sectionId', render: (unknown, record) => record.section?.name},
                    {title: "Родитель", dataIndex: 'parentId', key: 'parentId', render: (unknown, record) => record.parent?.name}
                ]}
                createFields={[
                    <ObjectSectionSelect
                        key="section"
                        label={"Раздел объекта"}
                        onChange={val => setValue("sectionId", val, entity, setEntity)}
                        fullWidth
                    />,
                    <ObjectSubSectionSelect
                        key="parent"
                        label={"Родительский подраздел (для подотдела)"}
                        sectionId={entity.sectionId}
                        onlyRoots
                        value={entity.parentId}
                        onChange={val => setValue("parentId", val, entity, setEntity)}
                        fullWidth
                    />
                ]}
                editFields={[
                    <ObjectSectionSelect
                        key="section"
                        label={"Раздел объекта"}
                        value={entity.sectionId}
                        onChange={val => setValue("sectionId", val, entity, setEntity)}
                        fullWidth
                    />,
                    <ObjectSubSectionSelect
                        key="parent"
                        label={"Родительский подраздел (для подотдела)"}
                        sectionId={entity.sectionId}
                        onlyRoots
                        value={entity.parentId}
                        onChange={val => setValue("parentId", val, entity, setEntity)}
                        fullWidth
                    />
                ]}
                detailsFields={[
                    "Раздел объекта: " + (entity.section?.name || entity.sectionId),
                    "Родитель: " + (entity.parent?.name || entity.parentId || "—")
                ]}
                removeFields={[
                    "Раздел объекта: " + (entity.section?.name || entity.sectionId),
                    "Родитель: " + (entity.parent?.name || entity.parentId || "—")
                ]}
            />
        </DashboardLayout>
    )
};

export default AnObjectSubSectionList;
